import React from 'react';

import PropTypes from 'prop-types';

const Label = ({ labelName }) => {
  return (
    <div className="main-content-form-headers" style={{ margin: '10px 0' }}>
      <span className="select-placeholder">{labelName}</span>
    </div>
  );
};

Label.propTypes = {
  labelName: PropTypes.string.isRequired
};

export default Label;
